import { render, staticRenderFns } from "./Form.vue?vue&type=template&id=16c2f681"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src724620054/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c2f681')) {
      api.createRecord('16c2f681', component.options)
    } else {
      api.reload('16c2f681', component.options)
    }
    module.hot.accept("./Form.vue?vue&type=template&id=16c2f681", function () {
      api.rerender('16c2f681', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/portals/Administration/Suppliers/PSRequestCred/Form.vue"
export default component.exports